import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AddDispatchOrganization from '../../../components/AddDispatchOrganization'
import Spinner from '../../../components/Spinner'
import { ApiContext } from '../../../hooks/api'
import { db } from '../../../firebase'
import { collection, doc, getDoc, getDocs, onSnapshot } from 'firebase/firestore'
import ContextMenu from '../../../components/ContextMenu'

export default function AddDispatchWrapper() {
  const navigate = useNavigate()
  const query = new URLSearchParams(useLocation().search)
  const incidentId = query.get('incidentId')

  const { user } = useContext(ApiContext)


  const [incident, setIncident] = useState(null)
  const [profile, setProfile] = useState(null)
  const [userTypes, setUserTypes] = useState([])
  const [dispatchBindings, setDispatchBindings] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!user?.id) return

    const fetchData = async () => {
      try {
        // 1. Get User Profile
        const userRef = doc(db, 'users', user.id); // Directly reference the user document
        const userSnap = await getDoc(userRef);
        
        if (!userSnap.exists()) {
          setError('User profile not found');
          return;
        }
        
        const userData = userSnap.data();
        setProfile(userData)

        // 2. Get Incident
        const incidentRef = doc(db, 'incidents', incidentId)
        const incidentSnap = await getDoc(incidentRef)
        if (!incidentSnap.exists()) {
          setError('Incident not found')
          return
        }
        setIncident({ id: incidentSnap.id, ...incidentSnap.data() })

        // 3. Get UserTypes
        const userTypesSnap = await getDocs(collection(db, 'userTypes'))
        const types = userTypesSnap.docs.map(doc => doc.data())
        setUserTypes(types)

        // 4. Dispatch Bindings
        const orgId = userData.organization?.id;
        if (!orgId) {
          setError('User organization not found');
          return;
        }

        const bindingsRef = collection(db, 'organizations', String(orgId), 'dispatch-bindings');
        const unsubscribe = onSnapshot(
          bindingsRef,
          (snapshot) => {
            const bindings = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const filtered = bindings.filter(
              binding => binding?.dispatchOrganization?.defaultUserType?.id
            );
            setDispatchBindings(filtered);
          },
          (err) => {
            console.error('Error fetching dispatch bindings:', err);
            setError('Failed to fetch dispatch bindings');
          }
        );

        return () => unsubscribe()
      } catch (err) {
        console.error('Error loading data:', err)
        setError('Unexpected error')
      }
    }

    fetchData()
  }, [user?.id, incidentId])

  if (error) return <div>Error: {error}</div>
  if (!incident || !profile || !userTypes.length || !dispatchBindings.length){
    return <Spinner />
  } 

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Add responders</h1>}></ContextMenu>
      {/* <h1 className='title'>Add responders</h1> */}
      <AddDispatchOrganization
        incident={incident}
        dispatchBindings={dispatchBindings}
        onDispatchOrganizationCreated={() => navigate(`/incidents/${incidentId}`)}
        userTypes={userTypes}
        profile={profile}
      />
    </div>
  )
}
